module.exports = __webpack_public_path__ + "img/渠道.66bdfdfb.svg";